import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// Global Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";

// Main Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";

// Legal Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";

/**
 * INTERNAL UTILITY: ScrollToTop
 * This component ensures that the browser window resets to the top 
 * every time a user navigates to a new page.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      {/* 1. Logic to reset scroll position on route change */}
      <ScrollToTop />
      
      {/* 2. Main Layout Container */}
      <div className="flex flex-col min-h-screen bg-white antialiased">
        
        {/* 3. Navigation Bar (Always Visible) */}
        <Navbar />

        {/* 4. Floating 'Go to Top' Icon */}
        <ScrollToTopButton />

        {/* 5. Main Content Area 
            'pt-24 md:pt-32' provides padding to avoid overlap with the fixed Navbar.
            'flex-grow' ensures the Footer is pushed to the bottom.
        */}
        <main className="flex-grow pt-24 md:pt-32">
          <Routes>
            {/* Standard Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Legal Routes */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />

            {/* 404 Redirect: Sends users back home if they enter an invalid URL */}
            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        {/* 6. Site-wide Footer */}
        <Footer />

      </div>
    </Router>
  );
}

export default App;